import React from 'react'
import Car from '../../components/containers/Car'

export default function Cart() {
  return (
    <div>
        <Car />
    </div>
  )
}
